<template>
  <div id="DocumentLimitTransactionInformation" class="sun not-full">
    본인은 ㈜펀다와 아래의 조건에 따라 여신거래를 함에 있어 아래 약관이 적용됨을 승인하고, 다음 각 조항을 확약합니다.
  </div>
</template>

<script>
export default {
  name: 'DocumentLimitTransactionInformation'
}
</script>

<style lang="scss" scoped>
  #DocumentLimitTransactionInformation {
    background-color: #f4faff;
    padding: 20px 36px;
    font-size: 16px;
    line-height: 1.5;
    color: #333333;
  }
</style>
